import { GAS_DRAIN_PER_SECOND, GAS_START_PERCENT } from "../../game/constants";

export class GasTank {
    private gasPercent = GAS_START_PERCENT;

    update(deltaMs: number, isMoving: boolean, modifier = 1): void {
        if (!isMoving || this.gasPercent <= 0) {
            return;
        }

        const deltaSeconds = deltaMs / 1000;
        this.gasPercent -= GAS_DRAIN_PER_SECOND * deltaSeconds * modifier;
        this.gasPercent = Math.max(0, this.gasPercent);
    }

    refill(percent: number): void {
        this.gasPercent = Math.min(100, this.gasPercent + percent);
    }

    getCurrentPercent(): number {
        return this.gasPercent;
    }

    isEmpty(): boolean {
        return this.gasPercent <= 0;
    }
}
